import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function ReportHero() {
  return <section className="relative w-full bg-paper border-b border-stone-200" data-id="element-93">
      <div className="max-w-4xl mx-auto px-6 pt-14 md:pt-20 pb-14 md:pb-16" data-id="element-94">
        {/* Report meta bar */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex flex-wrap items-center gap-x-4 gap-y-2 border-y border-ink py-3" data-id="element-95">
          <span className="eyebrow text-ink" data-id="element-96">Investigation</span>
          <span className="h-3 w-px bg-stone-300" aria-hidden="true" data-id="element-97" />
          <span className="eyebrow text-trust-600" data-id="element-98">Press Report</span>
          <span className="hidden sm:inline h-3 w-px bg-stone-300" aria-hidden="true" data-id="element-99" />
          <span className="hidden sm:inline text-xs text-stone-500 tracking-wide" data-id="element-100">
            Filed 04 July 2026 · Home Independence Hub Editorial Desk
          </span>
        </motion.div>

        {/* Kicker */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="eyebrow text-trust-600 mt-10 mb-5" data-id="element-101">
          The Independence Report · Energy · Preparedness · Water
        </motion.p>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.08
      }} className="font-serif tracking-tightest text-ink text-4xl md:text-6xl leading-[1.02]" style={{
        fontWeight: 500
      }} data-id="element-102">
          Inside the Push for True Home Independence
        </motion.h1>

        {/* Standfirst / lead */}
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.14
      }} className="mt-6 text-xl md:text-2xl text-stone-600 leading-relaxed font-light" data-id="element-103">
          A months-long investigation into how households are cutting reliance
          on the grid, the municipal supply and fragile supply chains — and
          which products actually deliver on their promises when independently
          tested.
        </motion.p>

        {/* Byline + verification */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6" data-id="element-104">
          <div className="text-sm text-stone-600" data-id="element-105">
            <span className="text-ink font-600" data-id="element-106">
              By the Editorial Investigations Team
            </span>
            <span className="block text-stone-500 text-xs mt-0.5" data-id="element-107">
              Reporting, data analysis and verification
            </span>
          </div>
          <span className="hidden sm:inline h-8 w-px bg-stone-200" aria-hidden="true" data-id="element-108" />
          <div className="inline-flex items-center gap-2 text-sm text-trust-700" data-id="element-109">
            <ShieldCheckIcon className="h-4 w-4" data-id="element-110" />
            <span className="font-600" data-id="element-111">
              Findings verified under the Agreexa Trust Framework®
            </span>
          </div>
        </motion.div>
      </div>

      {/* Lead image */}
      <motion.figure initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.7,
      delay: 0.15
    }} className="max-w-5xl mx-auto px-6 pb-16" data-id="element-112">
        <div className="aspect-[16/9] overflow-hidden rounded-sm" data-id="element-113">
          <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80" alt="A modern, self-sufficient home at dusk" className="h-full w-full object-cover" data-id="element-114" />
        </div>
        <figcaption className="mt-3 text-xs text-stone-500" data-id="element-115">
          Homeowners are investing in solar, storage and water independence at
          record rates. Photograph for Home Independence Hub.
        </figcaption>
      </motion.figure>
    </section>;
}